import { defineComponent as _defineComponent } from 'vue'
import { ArticleClickedData, BlockArticle } from '../types/editorial-types';

import PictureComp from '@/components/picture/PictureComp.vue';
import AuthorPreview from '@/features/editorial/components/AuthorPreview.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticlePreview',
  props: {
    article: null,
    index: null
  },
  emits: ["articleClicked", "authorClicked"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'articleClicked', data: ArticleClickedData): void;
	(e: 'authorClicked', id: string | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	article: BlockArticle;
	index: number;
};





function handleArticleClick(article: BlockArticle, index: number) {
	const articleData = {
		slug: article.content.fullPath,
		articleType: article.content.articleType,
		index,
	};

	emits('articleClicked', articleData);
}

function handleAuthorClick(id: string | undefined) {
	emits('authorClicked', id);
}

return { __sfc: true,props, emits, handleArticleClick, handleAuthorClick, PictureComp, AuthorPreview }
}

})